import React from 'react';
import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import { IBackToTopButtonProps } from '../BackToTopButton.types';

export default (ViewerComponent: React.ComponentType<IBackToTopButtonProps>) =>
  createComponentPreviewEntry(function ({
    previewWrapperProps = {},
    ...viewerProps
  }: PreviewWrapperProps<
    IBackToTopButtonProps,
    {
      componentViewMode?: string;
      isVisibleInEditor?: boolean;
      isMobileView?: boolean;
    }
  >) {
    return (
      <ViewerComponent
        {...viewerProps}
        isVisible={
          (previewWrapperProps.isMobileView &&
            previewWrapperProps.componentViewMode === 'editor' &&
            previewWrapperProps.isVisibleInEditor) ||
          viewerProps.isVisible
        }
      />
    );
  });
